import {
  faH1,
  faH2,
  faH3,
  faH4,
  faTextSize
} from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import type { Editor } from '@tiptap/react'
import { useEditorState } from '@tiptap/react'
import clsx from 'clsx'
import { editorDropdownItem, editorDropdownItemActive } from './EditorInput.css'
import { SplitButtonDropdown } from './SplitButtonDropdown'

export const HeadingDropdown = ({ editor }: { editor: Editor }) => {
  const editorState = useEditorState({
    editor,
    selector: ({ editor }) => ({
      isH1: editor.isActive('heading', { level: 1 }),
      isH2: editor.isActive('heading', { level: 2 }),
      isH3: editor.isActive('heading', { level: 3 }),
      isH4: editor.isActive('heading', { level: 4 }),
      isHeading: editor.isActive('heading')
    })
  })

  return (
    <SplitButtonDropdown
      isActive={editorState.isHeading}
      icon={<FontAwesomeIcon icon={faTextSize} />}
      onMainClick={() =>
        editor.chain().focus().toggleHeading({ level: 2 }).run()
      }
    >
      <button
        type="button"
        className={clsx(
          editorDropdownItem,
          editorState.isH1 && editorDropdownItemActive
        )}
        onClick={() => editor.chain().focus().toggleHeading({ level: 1 }).run()}
      >
        <FontAwesomeIcon icon={faH1} />
        Titre 1
      </button>
      <button
        type="button"
        className={clsx(
          editorDropdownItem,
          editorState.isH2 && editorDropdownItemActive
        )}
        onClick={() => editor.chain().focus().toggleHeading({ level: 2 }).run()}
      >
        <FontAwesomeIcon icon={faH2} />
        Titre 2
      </button>
      <button
        type="button"
        className={clsx(
          editorDropdownItem,
          editorState.isH3 && editorDropdownItemActive
        )}
        onClick={() => editor.chain().focus().toggleHeading({ level: 3 }).run()}
      >
        <FontAwesomeIcon icon={faH3} />
        Titre 3
      </button>
      <button
        type="button"
        className={clsx(
          editorDropdownItem,
          editorState.isH4 && editorDropdownItemActive
        )}
        onClick={() => editor.chain().focus().toggleHeading({ level: 4 }).run()}
      >
        <FontAwesomeIcon icon={faH4} />
        Titre 4
      </button>
    </SplitButtonDropdown>
  )
}
